import { FormattedMessage } from 'react-intl';

import FormattedDate from '@/features/common/components/FormattedDate';
import { MaintenanceDataItem } from '@/generated/GeneratedApiTypes';

export const AppointmentCell = ({ row }: { row: MaintenanceDataItem }) => {
    const { appointment } = row;
    if (!appointment) {
        return <td data-field="appointment" />;
    }
    return (
        <td data-field="appointment">
            <FormattedDate date={appointment.date} />
            <div className="text-size-12 text-color-dark">
                <FormattedMessage
                    id="intl-msg:vehicle-diagnostics.maintenance.table.maintenance-data.appointment-at"
                    values={{ workshop: appointment.workshop_name }}
                />
            </div>
        </td>
    );
};
